App.prototype.checkBoxChanged = function (unique_id) {
    var object = $("input[name='features[" + unique_id + "][]']");
    var anyCheckedOption = false;
    object.each(function () {
        if (this.checked) {
            anyCheckedOption = true;
        }
    });
    if (anyCheckedOption) {
        object.removeAttr('required');
    } else {
        object.attr('required', 'required');
    }
};

App.prototype.buildCheckbox = function (data, targetElement) {
    var options = '';
    var required = data.is_required ? ' required' : '';
    data.options.forEach(function (item) {
        var additionalPrice = item.price > 0 ? ' (+' + item.price + ' ' + translates.currency_code + ')' : '';
        options += '<div class="custom-control custom-checkbox mb-2">' +
            '<input type="checkbox" name="features[' + data.unique_id + '][]" class="custom-control-input" id="' + item.unique_id + '" value="' + item.unique_id + '" ' + required + ' onchange="App.prototype.checkBoxChanged(\'' + data.unique_id + '\')">' +
            '<label class="custom-control-label" for="' + item.unique_id + '">' + item.name + additionalPrice + '</label></div>';
    });
    var select = '<div class="form-group"><label>' + data.name + '</label>' + options + '</div>';
    targetElement.append(select);
};
